<div class="event" *ngIf="event"
     [ngClass]="{'selected': event.selected,'scheduled': event.scheduled}" (click)="event.selected=!event.selected">
  <div class="name">{{event.name}}</div>
  <div class="left">
    <div class="time">{{event.dateTimeOfEvent | date:'HH:mm'}}</div>
    <div class="rating">{{event.lengthInMinutes}}min</div>
<!--    <div class="select">-->
<!--      <input type="checkbox" id="chkIgnore_{{event.eventId}}" [(ngModel)]="event.selected">-->
<!--      <div><label for="chkIgnore_{{event.eventId}}">Select</label></div>-->
<!--    </div>-->
  </div>
  <div class="right">
    <div class="week">{{event.weekNumber}}wk</div>
    <div class="policy">{{event.distributorPolicy}}</div>
  </div>
  <div class="graph-container">
    <div class="wrap">
      <div class="sold-online"><mat-icon>language</mat-icon>{{event.soldRemotely}}</div>
      <div class="sold-local">{{event.soldQuantity}}<mat-icon>confirmation_number</mat-icon></div>
    </div>
    <div class="graph">
      <div class="container-q">
        <div class="total-q" [ngStyle]="{width: getSoldPercentageOfCapacity()}"></div>
        <div class="total-remote-q" [ngStyle]="{width: getSoldRemotelyPercentageOfCapacity()}"></div>
      </div>
    </div>
  </div>
</div>

